export default __webpack_public_path__ + "static/media/Happy Windows V recadrer.c9007fae.jpg";